// @ts-nocheck
import { Router } from '@gatsbyjs/reach-router';
import React from 'react';

import DocumentPage from '../components/DocumentPage/DocumentPage';
import AppLayout from '../components/layout/AppLayout';

const Home = () => {
  return (
    <AppLayout>
      <Router>
        <DocumentPage path="/" />
      </Router>
    </AppLayout>
  );
};
export default Home;
